import {CommandBase} from "./commandBase";
import {RemoteConstantsModel, UnitUpgradeStat, UnitUpgradeTrack} from "../models/remoteConstants.model";
import {mintNamespacedUid} from "../utils/uid.utils";

// Appends a Unit Upgrade track for a unit type and stat with one +1 level, and gives it a starting name.
// `newUid` is read back by the view so it can expand the card it just created.
export class AddUnitUpgradeTrackCommand extends CommandBase {
    unitType: string;
    stat: UnitUpgradeStat;
    newUid?: string;

    constructor(unitType: string, stat: UnitUpgradeStat) {
        super();
        this.unitType = unitType;
        this.stat = stat;
    }

    execute(data: RemoteConstantsModel): boolean {
        const tracks = data.unitUpgrades ?? [];
        const track: UnitUpgradeTrack = {
            // e.g. "upgrade.infantry-attack.0"
            uid: mintNamespacedUid('upgrade', `${this.unitType}-${this.stat}`, tracks.map(t => t.uid)),
            unitType: this.unitType,
            stat: this.stat,
            levels: [{price: 10, turns: 2, amount: 1}],
        };
        data.unitUpgrades = [...tracks, track];

        // A starting name and an empty description in every language, as ChangeLocalizationValuesCommand
        // writes them, so neither shows as a missing key.
        const name = `${this.unitType} ${this.stat === 'attack' ? 'Attack' : 'Defence'}`;
        for (const language in data.localization) {
            data.localization[language][track.uid] ??= name;
            data.localization[language][`${track.uid}.description`] ??= '';
        }

        this.newUid = track.uid;
        return true;
    }
}
